<template>
  <transition name="fade">
    <section class="Welcome" v-show="store.state.isReady && !isClosed">
      <section class="Welcome-content">
        <img class="Welcome-content-icon" src="@/assets/images/icon-360.svg" alt="">
        <p>
          <span>{{$t('welcome.h11')}}</span>
          <img src="@/assets/images/kenzo-homme-logo.svg" alt="">
          <span>{{$t('welcome.h12')}}</span>
        </p>
        <p v-html="$t('welcome.rule1')"></p>
        <p v-html="$t('welcome.text')"></p>
        <a class="Welcome-btn" @click="onClick()">{{$t('welcome.btn')}}</a>
      </section>
    </section>
  </transition>
</template>

<script>
export default {
  inject: ['store'],
  data() {
    return {
      isClosed: false,
    }
  },
  methods: {
    onClick() {
      this.isClosed = true;
      this.$emit('startxp')
    }
  }
}
</script>

<style lang="stylus" scoped>
.fade-enter-active,
.fade-leave-active
  transition: opacity 0.5s ease

.fade-enter-from,
.fade-leave-to
  opacity: 0
.Welcome
  position fixed
  width 100%
  height 100%
  z-index 4
  color white
  // background-image url('../../assets/bali-background.jpg')
  // background-size cover
  background-color rgba(6, 41, 92, 0.2) //06295c
  display flex
  align-items center
  justify-content center
  min-height 700px
  &-content
    padding 3% 5%
    background rgba(255,255,255, 0.2)
    border-radius 3px
    text-align center
    font-size 1.5rem
    margin-top 30px
    > img
      max-width 160px
      width 6vw
      min-width 80px
      // width 160px
      display inline-block
      margin-bottom 3vw
    p
      display flex
      align-content center
      align-items center
      justify-content center
      margin-bottom 20px
      span
        display inline-block

      > img
        display inline-block
        max-width 120px
        margin 0 10px
  &-btn
    text-transform uppercase
    border 2px solid white
    margin-top 3vw
    display inline-block
    cursor pointer
    font-family FuturaStd-bold, Arial, sans-serif
    padding 12px 15px 10px 15px
    transition all 200ms ease-out
    font-size 1.1rem

    &:hover
      color rgba(80, 80, 80, 1)
      background rgba(255, 255, 255, 0.9)

@media screen and (max-height: 800px)
  .Welcome
    &-content
      padding 30px 5%
      font-size 1.3rem
      margin-top 7vh
</style>